export const stats = {
  1: '未使用',
  2: '待拣货',
  3: '拣货中',
  4: '待分拣',
  5: '分拣中',
  6: '待打包',
  7: '打包中',
  8: '异常中'
}
export const statsList = () => {
  return Object.keys(stats).map(v => {
    return {
      label: stats[v],
      value: v
    }
  })
}
export const columns = [
  {
    title: "容器编号",
    dataIndex: "containerCode",
    key: "containerCode"
  },
  {
    title: "容器类型",
    dataIndex: "containerType",
    key: "containerType",
    customRender: text => {
      return {
        1: '拣货容器',
        2: '分拣容器'
      }[text];
    },
    width: 100
  },
  {
    title: "容量",
    dataIndex: "capacityType",
    key: "capacityType",
    customRender: text => {
      return {
        1: '5层4框',
        2: '4层5框'
      }[text];
    },
    width: 100
  },
  {
    title: "状态",
    dataIndex: "bizStatus",
    key: "bizStatus",
    customRender: text => {
      return stats[text];
    },
    width: 100
  },
  {
    title: "当前绑定人",
    dataIndex: "binderName",
    key: "binderName"
  },
  {
    title: "绑定时间",
    dataIndex: "bindTime",
    key: "bindTime"
  },
  {
    title: "容器商品",
    dataIndex: "productAmount",
    key: "productAmount",
    scopedSlots: { customRender: "productAmount" }
  },
  {
    title: "创建人",
    dataIndex: "creatorName",
    key: "creatorName"
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    key: "createTime"
  },
  {
    title: "操作",
    dataIndex: "actions",
    key: "actions",
    width: 170,
    fixed: 'right',
    scopedSlots: { customRender: "action" }
  },
];

export const productColumns = [
  {
    title: "图片",
    dataIndex: "productImageUrl",
    key: "productImageUrl",
    scopedSlots: { customRender: "productImageUrl" },
    width: 100
  },
  {
    title: "批次包编码",
    dataIndex: "pkgCode",
    key: "pkgCode"
  },
  {
    title: "国际发货单",
    dataIndex: "deliveryTaskCode",
    key: "deliveryTaskCode"
  },
  {
    title: "来源库位/容器",
    dataIndex: "sourceContainerCode",
    key: "sourceContainerCode",
    width: 150
  },
  {
    title: "数量",
    dataIndex: "productNums",
    key: "productNums",
    width: 150
  }
]
